import { render, staticRenderFns } from "./MonitoringLayoutCard.vue?vue&type=template&id=28de31bc&scoped=true&"
import script from "./MonitoringLayoutCard.vue?vue&type=script&lang=js&"
export * from "./MonitoringLayoutCard.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringLayoutCard.vue?vue&type=style&index=0&id=28de31bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de31bc",
  null
  
)

export default component.exports